module.exports = __webpack_public_path__ + "css/qrcode.svg?007c79accb8ec29301de0541474b322d";